var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#316AF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15776 17.1268L25.877 8.08242C25.9475 8.04836 26.0267 8.10918 26.012 8.18608L23.0291 23.77C23.0181 23.8275 22.9582 23.8616 22.9031 23.8416L17.5921 21.9147C17.5583 21.9025 17.5205 21.9103 17.4943 21.935L14.2528 24.9914C14.192 25.0487 14.0922 25.0057 14.0922 24.9222V21.0282C14.0922 21.0052 14.1006 20.9829 14.1157 20.9656L21.9529 11.9922C22.0288 11.9054 21.9138 11.7836 21.8228 11.8544L11.5098 19.8695C11.4786 19.8938 11.4356 19.8962 11.4019 19.8757L7.14977 17.2939C7.08523 17.2548 7.08978 17.1596 7.15776 17.1268Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.92f7c2342d6c0bdeba22c8d8fc32bd7b.svg";
export { ForwardRef as ReactComponent };